import { useStyles } from './AdvancedFilter.styles';
import { Typography } from '@material-ui/core';

interface AdvancedFilterStateProps {
  onModalOpen?: () => void;
  onResetFilter?: () => void;
}

export const AdvancedFilterState: React.FC<AdvancedFilterStateProps> = ({ onModalOpen, onResetFilter }) => {
  const classes = useStyles();

  return (
    <div className={classes.filterState}>
      <Typography className={classes.filterStateText}>
        Zastosowano zaawansowane filtrowanie po punktach za poszczególne zadania
      </Typography>
      <Typography className={[classes.filterStateText, classes.filterStateActionText].join(' ')} onClick={onModalOpen}>
        Przejdź do ustawień filtra
      </Typography>
      <Typography
        className={[classes.filterStateText, classes.filterStateActionText].join(' ')}
        onClick={onResetFilter}
      >
        Wyczyść filtrowanie zaawansowane
      </Typography>
    </div>
  );
};
